import UseMouseUpOutside from './UseMouseUpOutside';
import useShow from './useShow';

export default function useShowModal(ref,duration=300){
 
    const object=useShow(duration);

    UseMouseUpOutside(ref,object.close);

    return (object);
}

